<template>
  <el-dialog
    title="访问权限"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :visible.sync="show"
    width="40%"
  >
    <div class="dialog_box">
      <el-tabs type="border-card" v-model="selectTab" class="tabs-card-box" @tab-click="tabsClick">
        <el-tab-pane
          v-for="(item, index) in $store.state.select.authorityCategory"
          :key="index"
          :name="item.id+''"
          :label="item.nameOne"
        >
          <div class="tabs-option-box">
            <el-button size="mini" type="success" plain @click="authorizeAll"
              >全部授权</el-button
            >
            <el-button size="mini" type="warning" plain @click="cancelAll"
              >全部取消</el-button
            >
          </div>
          <div
            class="tab-pane-box"
            v-if="selectTab == '0'"
            v-loading="PCLoading"
          >
            <el-checkbox-group v-model="selectedPcList" size="mini">
              <el-checkbox
              style="margin-right:0px;width:50%"
                v-for="(value, index) in pcDataList"
                :label="value.id"
                :key="index"
                @change="selectOneData(value, $event)"
              >
                {{ value.authorizationName }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="tab-pane-box" v-else v-loading="AppLoading">
            <el-checkbox-group
              fill="rgba(64,158,255,0.2)"
              text-color="#303030"
              class="checkbox_group_box"
              v-model="selectedAppList"
              size="mini"
            >
              <el-checkbox-button
                class="checkbox_button_box"
                v-for="(value, index) in appDataList"
                style="margin:3px"
                :label="value.id"
                :key="index"
                @change="selectOneData(value, $event)"
              >
                <img
                  :src="value.moduleIcon"
                  alt=""
                  class="authority_icon"
                /><br />

                <div class="authority_name">{{ value.moduleName }}</div>
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    // roleId: {
    //   type: String
    // }
  },
  data() {
    //这里存放数据
    return {
      show: false,
      selectTab: "0",
      pcDataList: [],
      selectedPcList: [],
      appDataList: [],
      selectedAppList: [],
      authorizationPcList: [],
      PCLoading: false,
      AppLoading: false,
      roleId:""
    };
  },
  //监控data中的数据变化
  watch: {
    // showDialog: function(val) {
    //   this.show = val;
    //   this.selectTab='0'
    //   if (val) {
    //   }
    // }
  },
  //计算属性，类似于data概念
  computed: {
    authorityCategory() {
      return this.$store.state.select.authorityCategory;
    }
  },
  //方法集合
  methods: {
    init(roleid){
      this.roleId=roleid
      this.show=true;
      this.selectTab='0';
      this.getAuthorizationList("0");

    },
    handleClose() {
       this.show=false;
      // this.$emit("close");
    },
    tabsClick(tab) {
      this.selectTab = tab.index;
      if (this.selectTab == "1") {
        this.getAuthorizationList("1");
      } else {
        this.getAuthorizationList("0");
      }
    },
    authorizeAll() {
      let paramData = [];
      if (this.selectTab == "0") {
        paramData = this.pcDataList.map((element) => {
          return {
            genericId: element.id,
            permissionCategory: this.selectTab,
            roleId: this.roleId
          };
        });
        this.PCLoading = true;
      } else {
        paramData = this.appDataList.map((element) => {
          return {
            genericId: element.id,
            permissionCategory: this.selectTab,
            roleId: this.roleId
          };
        });
      }
      this.AppLoading = true;
      this.addAuthorizationList(paramData);
    },
    cancelAll() {
      let paramData = [];
      if (this.selectTab == "0") {
        paramData = this.pcDataList.map((element) => {
          return {
            roleId: this.roleId,
            genericId: element.id
          };
        });
        this.PCLoading = true;
      } else {
        this.AppLoading = true;
        paramData = this.appDataList.map((element) => {
          return {
            roleId: this.roleId,
            genericId: element.id
          };
        });
      }

      this.delAuthorizationList(paramData);
    },
    async getPcDataList() {
      let res = await this.$Http.pcAuthorityList("");
      if (res.code == 200) {
        this.PCLoading = false;
        this.pcDataList = res.data;
        this.selectedPcList = [];
        for (var i = 0; i < this.pcDataList.length; i++) {
          for (var j = 0; j < this.authorizationPcList.length; j++) {
            if (
              this.pcDataList[i].id == this.authorizationPcList[j].genericId &&
              this.authorizationPcList[j].permissionCategory == 0
            ) {
              this.selectedPcList.push(this.pcDataList[i].id);
            }
          }
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getAppDataList() {
      let res = await this.$Http.appAuthorityList("");
      
      this.AppLoading = true;
      if (res.code == 200) {
        this.appDataList = res.data;
        this.selectedAppList = [];
        for (var i = 0; i < this.appDataList.length; i++) {
          for (var j = 0; j < this.authorizationAppList.length; j++) {
            if (
              this.appDataList[i].id ==
                this.authorizationAppList[j].genericId &&
              this.authorizationAppList[j].permissionCategory == 1
            ) {
              this.selectedAppList.push(this.appDataList[i].id);
            }
          }
        }
         this.AppLoading = false;
        // console.log(this.appDataList)
      } else if (res.code == 101) {
          this.AppLoading = false;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
          this.AppLoading = false;
      }
    },
    selectOneData(value, selectStatus) {
      if (selectStatus == false) {
        let paramData = [
          {
            roleId: this.roleId,
            genericId: value.id
          }
        ];
        this.delAuthorizationList(paramData);
      } else if (selectStatus == true) {
        let paramData = [
          {
            genericId: value.id,
            permissionCategory: this.selectTab,
            roleId: this.roleId
          }
        ];
        this.addAuthorizationList(paramData);
      }
    },
    async delAuthorizationList(paramData) {
      let res = await this.$Http.delAuthorizationList(paramData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "取消授权成功"
        });

        this.getAuthorizationList(this.selectTab);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async addAuthorizationList(paramData) {
      let res = await this.$Http.addAuthorizationList(paramData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "添加授权成功"
        });

        this.getAuthorizationList(this.selectTab);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getAuthorizationList(cates) {
      let res = await this.$Http.getAuthorizationList(
        { roleId: this.roleId },
        true
      );
      if (res.code == 200) {
        switch (cates) {
          case "0":
            this.authorizationPcList = [];
            res.data.forEach((element) => {
              if (element.permissionCategory == 0) {
                this.authorizationPcList.push(element);
              }
            });
            this.getPcDataList();
            break;
          case "1":
            this.authorizationAppList = [];
            res.data.forEach((element) => {
              if (element.permissionCategory == 1) {
                this.authorizationAppList.push(element);
              }
            });
            this.getAppDataList();
            break;
        }
      } else if (res.code == 101) {
        switch (cates) {
          case "0":
            this.authorizationPcList = [];
            this.getPcDataList();
            break;
          case "1":
            this.authorizationAppList = [];
            this.getAppDataList();
            break;
        }
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>
